// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
declare const require: any;
export const environment = {
  production: false,
  urlProduction: 'http://testdes.passer.live/',
  urlBeta: 'http://testbetades.passer.live/',
  urlPortalWeb: 'https://testtransporte.passer.live/',
  urlDriverPasserPrint: 'https://testdownloads-681422137549-us-east-1-an.s3.us-east-1.amazonaws.com/updates/agent/version.json',
  serverUrl: 'https://testadminapi.passer.live',
  serverUrlAdmin: 'https://testadminapi.passer.live',
  serverUrlAdminBeta: 'https://testbetadesapi.passer.live',
  serverUrlPasser: 'https://testapi.passer.live',
  serverUrlPasserPolicy: 'https://testing.passer.live/legal/business-partner',
  serverUrlPasserPublicTransp: 'https://testing.passer.live/enterprises',
  serverUrlCatalogs: 'https://testcatalogs.passer.live/api',
  serverUrlDriver: 'https://testdriverapi.passer.live/api',
  serverServices: 'https://testatvbridge.passer.live/api',
  serverStats: 'https://test.statistics.passer.live/api/v1',
  serverAdmin: 'https://slsportal.passer.live/development',
  serverUrlReportsFinished: 'https://testreports.passer.live/api/settlements',
  serverUrlReportsFinishedConsigments: 'https://testreports.passer.live/api/consignment/consignment',
  serverURLReportsConsolidatedEcommerce: 'https://testreports.passer.live/api/consolidatedSettlements/ecommerce',
  serverURLReportsConsolidatedPhysicalOffices: 'https://testreports.passer.live/api/consolidatedSettlements/ticketOffice',
  serverURLReportCancellations: 'https://testreports.passer.live/api/consolidatedSettlements/refunds',
  serverURLReportsConsolidatedPhysicalDrivers: 'https://testreports.passer.live/api/consolidatedSettlements/drivers',
  serverURLReportsSellerBreakdown: 'https://testreports.passer.live/api/salesBreakdown/ticketOffice',
  serverURLReportsDriverBreakdown: 'https://testreports.passer.live/api/salesBreakdown/salesDriver',
  serverURLReportsDriverBreakdownRates: 'https://testreports.passer.live/api/salesBreakdown/driverRevenue',
  serverURLReportsExcelLogistic: 'https://testreports.passer.live/api/logistics/logisticsSales',
  serverURLReportExcelLogisticConsolidated: 'https://testreports.passer.live/api/logistics/consolidatedLogistics',
  serverURLReportDriverRoles: 'https://testreports.passer.live/api/serviceRoles/driver',
  serverURLReportDriver: 'https://testreports.passer.live/api/drivers',
  serverURLReportRoles: 'https://testreports.passer.live/api/serviceRoles/roles',
  serverURLReportJourney: 'https://testreports.passer.live/api/journey/journeyLog',
  serverURLReportAresep: 'https://testreports.passer.live/api/journey/aresep/report',
  socket_url: 'https://testmapsocket.passer.live',
  socket_ticket_url: 'https://testsockets.passer.live',
  socket_print_url: 'https://testprintsocket,passer.live',
  passerIdP:{
    options: {
      serverUrl:  "https://testidp.passer.live",
      serverUrlBeta:  "https://testbetaidp.passer.live",
      clientId: "6389772b9eed34d1311bb8a2",
      clientsecret: "&qC7gNTYx*hcmAx9KqnwqST",
      scope: "openid profile email phone offline_access",
      resource: "https://testadminapi.passer.live",
      callbackRecoveryPasswordBaseUrl: "https://testing.passer.live/reset-password"
    }
  },
  ffKey: 'dev_gdfZ8yMKOf3wxmzXNQaMLvrLDaMy1LHgLy10DyvO2w',
  desVersion: require('../../package.json').version,
  sentry: 'https://01017a69b42d6f6a007ea2864220dd3e@o4507924866400256.ingest.us.sentry.io/4510161516167168',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
